import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import {
  InMemoryCache,
  ApolloProvider,
  ApolloClient,
  ApolloLink,
  HttpLink,
  from,
} from "@apollo/client";
import { store } from "./app/store";
import { Provider } from "react-redux";
import { persistStore } from "redux-persist";
import { onError } from "@apollo/client/link/error";
import { PersistGate } from "redux-persist/integration/react";
import { RouterProvider } from "react-router-dom";
import router from "./App";
import "./index.css";
import { Toaster } from "react-hot-toast";
import reportWebVitals from "./reportWebVitals";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import { initLocationOnce } from "./app/initLocation";

let persistor = persistStore(store);

const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors)
    graphQLErrors.forEach(({ message, locations, path }) =>
      console.log(
        `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
      )
    );

  if (networkError) console.log(`[Network error]: ${networkError}`);
});

// GraphQL endpoint - change to http://localhost:1966/graphql for local development
const GRAPHQL_URI = process.env.REACT_APP_GRAPHQL_URI || "https://lol.djeliba.com/graphql";
const httpLink = new HttpLink({ uri: GRAPHQL_URI });

const authMiddleware = new ApolloLink((operation, forward) => {
  // add the authorization to the headers
  operation.setContext(({ headers = {} }) => ({
    headers: {
      ...headers,
      Authorization: `Bearer ${localStorage.getItem("access_token")}` || null,
    },
  }));

  return forward(operation);
});

const client = new ApolloClient({
  cache: new InMemoryCache(),
  credentials: "include",
  link: from([errorLink, authMiddleware, httpLink]),
});

// Kick off location initialization without blocking render
initLocationOnce();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ApolloProvider client={client}>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <Toaster position="top-center" reverseOrder={true} />
          <RouterProvider router={router} />
        </PersistGate>
      </Provider>
    </ApolloProvider>
  </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
